import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React from "react";
export var WishlistContext = React.createContext({
  addError: null,
  addLoading: false,
  addWishlistProductVariant: function () {
    var _addWishlistProductVariant = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                data: null
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function addWishlistProductVariant() {
      return _addWishlistProductVariant.apply(this, arguments);
    }

    return addWishlistProductVariant;
  }(),
  error: null,
  loading: false,
  removeError: null,
  removeLoading: false,
  removeWishlistProductVariant: function () {
    var _removeWishlistProductVariant = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", {
                data: null
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function removeWishlistProductVariant() {
      return _removeWishlistProductVariant.apply(this, arguments);
    }

    return removeWishlistProductVariant;
  }(),
  wishlist: null
});
WishlistContext.displayName = "WishlistContext";